import { Button } from '~/components/general/Button'
import { trackEvent } from '~/utils/tracking'
import { FlexContainer, FlexItem } from '~/components/Grid'
import { createOptimizedContentfulImage } from '~/libs/contentful/helpers'
import { Asset } from 'contentful'
import { TypeBottomGetBlock } from '~/types/contentful'

type GetEdgeProps = {
  section: TypeBottomGetBlock<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const GetEdge = ({ section }: GetEdgeProps) => {
  const { fields } = section
  if (!fields) return <></>

  const bgImage =
    (fields?.images as Asset<'WITHOUT_UNRESOLVABLE_LINKS', string>[])[0]?.fields ||
    (fields?.images as Asset<'WITHOUT_UNRESOLVABLE_LINKS', string>[])[0].fields

  const handleCTABtnClick = () => {
    trackEvent('homepage_click_cta', {
      block: fields.blockId,
      target: fields.buttonLink as string,
      homepage_CTA: fields.buttonName as string,
    })
  }

  return (
    <div
      className="rounded-[40px] min-h-[660px] justify-center items-center flex overflow-hidden m-[100px_-32px_-100px] bg-neutral-5 max-md:rounded-3xl max-md:m-[40px_-18px_-24px] max-lg:m-[70px_-26px_-72px] max-xl:rounded-[32px] max-xl:min-h-[548px] max-xl:m-[70px_-32px_-72px]"
      data-block-id={fields.blockId}
      style={{
        backgroundImage: bgImage?.file
          ? `url(${createOptimizedContentfulImage({ file: bgImage.file })})`
          : '',
        backgroundSize: 'cover',
      }}
    >
      <FlexContainer>
        <FlexItem desktop={12}>
          <div className="flex flex-col items-center text-neutral-90 mt-5">
            <h2 className="text-center mb-5 max-md:mb-2 text-2xl max-md:max-w-[300px] max-w-[650px]">
              {fields.title}
            </h2>

            <Button
              text={fields.buttonName}
              type={'link'}
              href={fields.buttonLink}
              size={'m'}
              onClick={handleCTABtnClick}
            />
          </div>
        </FlexItem>
      </FlexContainer>
    </div>
  )
}
